import { trace } from 'rytm-helpers'
import Controller from './Controller'
import { playSoundMain, stopSoundMain, playSoundAmbient, stopSoundAmbient } from './../tsaw/actions/actions_audio'
import { navSoundShowed, navSoundHidden } from './../shared/tsaw-nav-sound'

class ChapterSoundController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.startPlayback()
  }
  addEventListeners() {
    super.addEventListeners()
  }
  removeEventListeners() {
    super.removeEventListeners()
    this.stopPlayback()
  }
  /**
   * ###########
   * ### OWN ###
   */
  startPlayback() {
    const audioPath = this.getAudioPath()
    if (audioPath) {
      const params = {
        container: ".waveform-main", 
        scrollParent: false,
      }
      playSoundMain(audioPath, params)
      navSoundShowed()
    }
    const audioBgPath = this.getAudioBgPath()
    if (audioBgPath) {
      const params = {
        container: ".waveformcanvas-bg", 
        loop: true,
      }
      playSoundAmbient(audioBgPath, params)
    }
  }
  stopPlayback() {
    const audioPath = this.getAudioPath()
    if (audioPath) {
      stopSoundMain()
      navSoundHidden()
    }
    const audioBgPath = this.getAudioBgPath()
    if (audioBgPath) {
      stopSoundAmbient()
    }
  }
  getAudioPath() {
    const container = document.querySelector(this.getContainerSelector())
    return container.dataset.chapterSound
  }
  getAudioBgPath() {
    const container = document.querySelector(this.getContainerSelector())
    return container.dataset.chapterBg
  }

}

export default ChapterSoundController;